const queryParamsOptions = {
	LIST: 'List',
	IGNORE_ALL: 'Ignore all',
	INCLUDE_ALL: 'Include all'
};

export { queryParamsOptions };
